import { Component, OnInit, forwardRef, ViewChild, Input, NgZone } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { PagerControlComponent } from '../../pager/pager-control.component';
import { BillingInvoiceItemEditInfo } from '../../../../model/billing/billing-invoice-item-edit-info';
import { Base64ToBlobService } from '../../../../services/base64-to-blob.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { BillingInvoiceEntityService } from '../../../../services/billing/billing-invoice/billing-invoice-entity.service';
import { BillingInvoiceEditService } from '../../../../services/billing/billing-invoice/billing-invoice-edit.service';
import { DownloadLocalFileService } from '../../../../services/download-local-file.service';

export const BILLING_INVOICE_ITEM_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BillingInvoiceItemEntityEditComponent),
  multi: true,
};

@Component({
  selector: 'app-billing-invoice-item-entity-edit',
  providers: [BILLING_INVOICE_ITEM_CONTROL_VALUE_ACCESSOR],
  templateUrl: './billing-invoice-item-entity-edit.component.html',
  styleUrls: ['./billing-invoice-item-entity-edit.component.css']
})
export class BillingInvoiceItemEntityEditComponent implements ControlValueAccessor, OnInit {

  @Input() id: string;
  hideElement = true;
  loadingAction: boolean;
  dataSource = new MatTableDataSource([]);
  displayedColumns: string[] = ['protocol', 'patientFullName',
                                'practiceName', 'amount', 'taxAmount',
                                'Star'];

  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  onChange;
  items: BillingInvoiceItemEditInfo[];

  constructor( private base64ToBlobService: Base64ToBlobService,
               private zone: NgZone,
               private downloadLocalFileService: DownloadLocalFileService,
               private billingInvoiceEditService: BillingInvoiceEditService,
               private billingInvoiceEntityService: BillingInvoiceEntityService,
               private notificationToastService: NotificationToastService ) { }

  ngOnInit() {
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
  }

  writeValue(items: BillingInvoiceItemEditInfo[]): void {
    this.items = items;
    this.pager.setItems(this.items);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeBillingInvoiceItems(): void {
    if (this.onChange) {
      this.onChange(this.items);
    }
  }

  deleteItem(item: BillingInvoiceItemEditInfo) {
    const index = this.items.indexOf(item, 0);
    if (index > -1) {
      this.items.splice(index, 1);
      this.pager.setItems(this.items);
      this.changeBillingInvoiceItems();
   }
  }

  async export() {
    try {
      if ( this.pager.getAllItems().length > 0 ) {
        this.loadingAction = true;
        const file = await this.billingInvoiceEntityService.createExcelAdjustment(this.items);
        const fileName =  this.billingInvoiceEditService.getParentInvoiceCompleteNumber();

        console.log(fileName);

        this.downloadLocalFileService.downLoadFile(file, fileName, 'xlsx');
      }
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
    } finally {
      this.loadingAction = false;
    }
  }

  import(event) {

      for (let index = 0; index < event.length; index++) {
        const element = event[index];
        const reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = (_event) =>  {

          this.zone.run(async () => {
            try {
              this.loadingAction = true;
              const base64Url =  <string>reader.result;
              const fileBase64 = base64Url.split('base64,')[1];
              const info = await this.billingInvoiceEntityService.
                  billingInvoiceItemEditInfosAdjustment(fileBase64, this.pager.getAllItems());
              this.writeValue(info);
              this.changeBillingInvoiceItems();
            } catch ( err ) {
              this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
            } finally {
              this.loadingAction = false;
            }
          });
        }
      }
  }
}
